import React from 'react';
import { CTAButton, TrustLine } from './CTAButton';
import { BOX_IMAGE, PURCHASE_ANCHOR } from '../data/content';
export function Hero() {
  return <header className="bg-navy px-3 pb-4 pt-3 text-center sm:px-6 sm:pb-5 sm:pt-4" data-id="element-76" data-mp="eilc6zjmglae">
      <h1 className="font-heading text-[1.35rem] font-bold uppercase leading-[1.08] text-white sm:text-[2.4rem]" data-id="element-77" data-mp="9lbfqzxtf9d2">
        The Complete Visual Reference System for{' '}
        <span className="text-gold" data-id="element-78" data-mp="129qwps0ic1r1">Clinical Lab Science</span>
      </h1>
      <p className="mx-auto mt-1.5 max-w-xl text-[0.8rem] leading-[1.35] text-white/85 sm:text-[0.95rem]" data-id="element-79" data-mp="xae6cxafgcjp">
        Stop studying laboratory results as isolated values. Access visual
        atlases, pattern comparisons, morphology references, correlation maps,
        verification tools and integrated laboratory resources. Keep essential
        laboratory patterns organized in one professional system.
      </p>
      <p className="mt-1 font-body text-[0.74rem] font-bold uppercase leading-tight text-gold sm:text-sm" data-id="element-80" data-mp="381xl8y8vx2a6">
        Less time searching. More visual clarity for every laboratory review.
      </p>

      <a href={PURCHASE_ANCHOR} className="mt-2 block" data-id="element-81" data-mp="3o85bzdbr655m">
        <img src={BOX_IMAGE} alt="CLINICAL LAB VISUAL ATLAS™ complete 6-in-1 visual reference system box set" className="mx-auto w-full max-w-[270px] drop-shadow-2xl sm:max-w-[330px]" data-id="element-82" data-mp="3o5j4fdov3pne" />
      </a>

      <div className="mx-auto mt-2 max-w-md" data-id="element-83" data-mp="30iaz4vrfogld">
        <CTAButton label="🧪 Yes! I want the complete system" data-id="element-84" data-mp="30ggezjnzksic" />
        <p className="mt-1.5 font-body text-[0.66rem] font-extrabold uppercase tracking-[0.12em] text-white sm:text-xs" data-id="element-85" data-mp="3599ent4llank">
          Get Clinical Lab Visual Atlas™ today
        </p>
        <TrustLine className="mt-1 !text-white/75" data-id="element-86" data-mp="2viomoojfj4dm" />
      </div>
    </header>;
}